import { Component, Prop, h, Host } from '@stencil/core';
import { arrow_right } from 'pn-design-assets/pn-assets/icons.js';

@Component({
  tag: 'pn-marketweb-icon',
  styleUrl: 'pn-marketweb-icon.scss',
})
export class PnmarketwebIcon {
  /** The SVG content of the icon you want to use */
  @Prop() symbol: string = null;
  /** Medium is default but you can pass "small" for a 16x16 icon */
  @Prop() small: boolean = false;
  /** Check for the available colors in the knobs panel in the story */
  @Prop() color: string = 'black';

  render() {
    return (
      <Host>
        <pn-icon icon={this.symbol} color={this.color} small={this.small}></pn-icon>
      </Host>
    );
  }
}
